export var TRANSITION_TIME_DEFAULT = '300ms';
export var TRANSITION_TIME_MOBILE = '400ms';
export var TRANSITION_EASE_DEFAULT = 'ease';
export var TRANSITION_EASE_MOBILE = TRANSITION_EASE_DEFAULT;
export var TRANSITION_DEFAULT = "".concat(TRANSITION_TIME_DEFAULT, " ").concat(TRANSITION_EASE_DEFAULT);
export var TRANSITION_DEFAULT_MOBILE = "".concat(TRANSITION_TIME_MOBILE, " ").concat(TRANSITION_EASE_MOBILE);